import React from "react";

const Sidebar = ({
  handleChangeInput,
  handleCheckBox,
  onSubmit,
  applyFilters,
  filtersChanged,
  handleKeyPress,
  filters,
  impactCategory,
  nftCategory,
  clearAll,
}) => {
  // Helper function to check if any filters are currently applied
  const hasActiveFilters = () => {
    if (!filters) return false;

    return (
      filters.impactCategory ||
      filters.nftCategory ||
      filters.username ||
      filters.itemName ||
      filters.campaignName ||
      filters.priceMin ||
      filters.priceMax ||
      (filters.percentageMin && filters.percentageMin > 0) ||
      (filters.percentageMax && filters.percentageMax < 100)
    );
  };

  return (
    <div
      className="bg-white dark:bg-jacarta-700 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600 lg:sticky lg:top-24"
      style={{ padding: 'clamp(1rem, 3vw, 1.5rem)' }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          applyFilters();
        }}
        className="space-y-4 sm:space-y-5"
      >
        {/* Search */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Search Items
          </label>
          <input
            type="text"
            name="itemName"
            value={filters?.itemName || ""}
            onChange={handleChangeInput}
            onKeyPress={handleKeyPress}
            placeholder="Search by item name..."
            className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
          />
        </div>

        {/* Creator Search */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Creator
          </label>
          <input
            type="text"
            name="username"
            value={filters?.username || ""}
            onChange={handleChangeInput}
            onKeyPress={handleKeyPress}
            placeholder="Search by username..."
            className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
          />
        </div>

        {/* Campaign Name */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Campaign
          </label>
          <input
            type="text"
            name="campaignName"
            value={filters?.campaignName || ""}
            onChange={handleChangeInput}
            onKeyPress={handleKeyPress}
            placeholder="Search by campaign..."
            className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
          />
        </div>

        {/* Impact Category */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Impact Category
          </label>
          <select
            name="impactCategory"
            value={filters?.impactCategory || ""}
            onChange={handleChangeInput}
            className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
          >
            <option value="">All Categories</option>
            {!!impactCategory?.length &&
              impactCategory.map((v, i) => (
                <option key={i} value={v}>
                  {v}
                </option>
              ))}
          </select>
        </div>

        {/* NFT Category */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Impact Art Category
          </label>
          <select
            name="nftCategory"
            value={filters?.nftCategory || ""}
            onChange={handleChangeInput}
            className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
          >
            <option value="">All Types</option>
            {!!nftCategory?.length &&
              nftCategory.map((v, i) => (
                <option key={i} value={v}>
                  {v}
                </option>
              ))}
          </select>
        </div>

        {/* Price Range */}
        <div>
          <label
            className="block font-medium text-jacarta-700 dark:text-white mb-1.5"
            style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.875rem)' }}
          >
            Price Range (USD)
          </label>
          <div className="grid grid-cols-2 gap-2">
            <input
              type="number"
              name="priceMin"
              value={filters?.priceMin || ""}
              onChange={handleChangeInput}
              placeholder="Min"
              min="0"
              step="0.01"
              className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
            />
            <input
              type="number"
              name="priceMax"
              value={filters?.priceMax || ""}
              onChange={handleChangeInput}
              placeholder="Max"
              min="0"
              step="0.01"
              className="w-full px-3 py-2.5 sm:py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20 text-sm"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 pt-2">
          <button
            type="submit"
            disabled={!filtersChanged}
            className={`flex-1 px-4 py-3 sm:py-2.5 rounded-xl sm:rounded-lg text-sm font-medium transition-all active:scale-[0.98] ${
              filtersChanged
                ? "bg-accent text-white hover:bg-accent-dark"
                : "bg-jacarta-100 dark:bg-jacarta-600 text-jacarta-500 dark:text-jacarta-400 cursor-not-allowed"
            }`}
          >
            Apply Filters
          </button>
          <button
            type="button"
            onClick={clearAll}
            disabled={!hasActiveFilters()}
            className={`px-4 py-3 sm:py-2.5 rounded-xl sm:rounded-lg text-sm font-medium transition-all active:scale-[0.98] ${
              hasActiveFilters()
                ? "bg-jacarta-100 dark:bg-jacarta-600 text-jacarta-700 dark:text-white hover:bg-jacarta-200 dark:hover:bg-jacarta-500"
                : "bg-jacarta-50 dark:bg-jacarta-700 text-jacarta-400 dark:text-jacarta-500 cursor-not-allowed"
            }`}
          >
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};

export default Sidebar;
